import React from 'react';
import { withOptionalId } from '@lib/withOptionalId';
import { Section, Container } from '@layout';

interface ProjectsV1Props {
  sectionID?: string;
  className?: string;
  children?: React.ReactNode;
  asideChildren?: React.ReactNode;
}

const ProjectsV1: React.FC<ProjectsV1Props> = ({
  sectionID,
  className,
  children,
  asideChildren,
}) => (
  <Section
    {...withOptionalId(sectionID)}
    className={`${className ? className : ''}`.trim()}
  >
    <Container>
      <div className='grid-5'>
        <div className='project-content grid-span-3l'>{children}</div>
        <div className='project-aside grid-span-2r'>{asideChildren}</div>
      </div>
    </Container>
  </Section>
);

export default ProjectsV1;
